<template>
  <v-card>
    <AppTitleCard>
      <template slot="title">
        Estadistica pedidos
      </template>
      <template slot="button">
        <v-btn class="mt-0" dark color="info" small @click="date_shipping = !date_shipping">
          <span v-if="!date_shipping">Fecha de entrega</span>
          <span v-else>Fecha de compra</span>
        </v-btn>
        <v-btn class="mt-0" dark color="accent" small @click="type_statistic = !type_statistic">
          <span v-if="!type_statistic">Pedidos</span>
          <span v-else>Ingresos</span>
        </v-btn>
      </template>
    </AppTitleCard>
    <v-card-text>
      <LineChart :chart-data="datacollectionOrders" :options="optionsData"></LineChart>
    </v-card-text>
  </v-card>
</template>

<script>
import AppTitleCard from '../useful/titleCard.vue'
import LineChart from '../useful/lineChartt'

export default {
  name: 'DashboardOrder',
  components: {
    LineChart,
    AppTitleCard
  },
  props: ['ordersDate', 'ordersShipping'],
  data() {
    return {
      datacollectionOrders: {},
      optionsData: {
        hover: {
          // Overrides the global setting
          mode: 'index'
        },
        line: {
          backgroundColor: 'transparent'
        },
        legend: {
          labels: {
            fontColor: 'grey',
            fontSize: 12
          }
        },
        scales: {
          yAxes: [
            {
              ticks: {
                fontColor: 'grey',
                fontSize: 8,
                suggestedMin: 0
              }
            }
          ],
          xAxes: [
            {
              ticks: {
                fontColor: 'grey',
                fontSize: 12,
                stepSize: 1,
                beginAtZero: true
              }
            }
          ]
        },
        reponsive: true,
        maintainAspectRatio: false
      },
      date_shipping: false,
      type_statistic: false
    }
  },
  computed: {
    statusFinish() {
      return this._.filter(this.items.orders, ['status', 4])
    },
    statusShipping() {
      return this._.filter(this.items.orders, ['status', 3])
    },
    statusProcess() {
      return this._.filter(this.items.orders, ['status', 2])
    },
    missingDesign() {
      return this._.filter(this.items.orders, ['design', false])
    },
    missingPrint() {
      return this._.filter(this.items.orders, ['print', false])
    },
    missingGeo() {
      return this._.filter(this.items.orders, ['location', false])
    },
    missingDocument() {
      return this._.filter(this.items.orders, ['document', false])
    }
  },
  watch: {
    ordersDate(e) {
      if (e && this.date_shipping) {
        this.setCollectionOrders(e.today, e.last_year)
      }
    },
    ordersShipping(e) {
      if (e && !this.date_shipping) {
        this.setCollectionOrders(e.today, e.last_year)
      }
    },
    type_statistic() {
      if (!this.date_shipping) {
        this.setCollectionOrders(this.ordersShipping.today, this.ordersShipping.last_year)
      } else {
        this.setCollectionOrders(this.ordersDate.today, this.ordersDate.last_year)
      }
    },
    date_shipping(e) {
      if (!e) {
        this.setCollectionOrders(this.ordersShipping.today, this.ordersShipping.last_year)
      } else {
        this.setCollectionOrders(this.ordersDate.today, this.ordersDate.last_year)
      }
    }
  },
  methods: {
    setCollectionOrders(orders, last_years) {
      const today = this.$moment().format('YYYY-MM-DD')
      // day -15 days
      const day = this.$moment(today)
        .subtract(15, 'days')
        .format('YYYY-MM-DD')
      // day + 15 days
      const day2 = this.$moment(today)
        .add(15, 'days')
        .format('YYYY-MM-DD')
      // foreach day and day2
      const labels = []
      const order_today = []
      const order_last_year = []
      for (
        let i = day;
        i <= day2;
        i = this.$moment(i)
          .add(1, 'days')
          .format('YYYY-MM-DD')
      ) {
        labels.push(i)
        // get day and month in i
        const day = this.$moment(i).format('DD')
        const month = this.$moment(i).format('MM')
        const result = orders.filter(e => {
          const day_order = this.$moment(e.date).format('DD')
          const month_order = this.$moment(e.date).format('MM')
          return day === day_order && month === month_order
        })
        if (result.length > 0) {
          if (!this.type_statistic) {
            order_today.push(result[0].total)
          } else {
            order_today.push(result[0].valor_total)
          }
        } else {
          order_today.push(0)
        }
        const result2 = last_years.filter(e => {
          const day_order = this.$moment(e.date).format('DD')
          const month_order = this.$moment(e.date).format('MM')
          return day === day_order && month === month_order
        })
        if (result2.length > 0) {
          if (!this.type_statistic) {
            order_last_year.push(result2[0].total)
          } else {
            order_last_year.push(result2[0].valor_total)
          }
        } else {
          order_last_year.push(0)
        }
      }
      this.datacollectionOrders = {
        labels,
        datasets: [
          {
            label: 'Pedidos este año',
            borderColor: '#4caf50',
            showLine: true,
            spanGaps: false,
            data: order_today,
            lineTension: 0,
            scaleStepWidth: 5
          },
          {
            label: 'Pedidos año pasado',
            borderColor: '#ff1744',
            showLine: true,
            spanGaps: false,
            data: order_last_year,
            lineTension: 0,
            scaleStepWidth: 5
          }
        ]
      }
    }
  }
}
</script>
